module.exports = __webpack_public_path__ + "static/media/att_29.e2cd4dbe.jpg";